import React from 'react'
import HTMLText from './HTMLText'

function HighlightItem({item}) {
  return (
    <li className="account-subscription__highlights-item">
      <HTMLText html={item} />
    </li>  
  )
}

export default React.memo(HighlightItem)